import { Callout } from "../components/Callout.js";
import { ScreenshotBox } from "../components/ScreenshotBox.js";

export const meta = {
  title: "ユーザー招待・権限管理",
  updatedAt: "2026-07-23",
};

export function Content() {
  return (
    <>
      <p>
        1 つのテナント（HubSpot ポータル）に複数のユーザーを招待して共同利用できます。
        ロールによって操作範囲が異なります。
      </p>

      <h2>ロールの種類</h2>
      <p>
        ロール権限は「ユーザー」タブの下部にも記載されています:
      </p>
      <table style={{ width: "100%", borderCollapse: "collapse", margin: "12px 0" }}>
        <thead>
          <tr style={{ background: "#faf9f7" }}>
            <th style={th()}>ロール</th>
            <th style={th()}>主な権限</th>
          </tr>
        </thead>
        <tbody style={{ fontSize: 13 }}>
          <tr>
            <td style={td()}><strong>オーナー</strong></td>
            <td style={td()}>全操作・課金設定・他のオーナー設定</td>
          </tr>
          <tr>
            <td style={td()}><strong>管理者</strong></td>
            <td style={td()}>ユーザー招待・接続設定・送信</td>
          </tr>
          <tr>
            <td style={td()}><strong>メンバー</strong></td>
            <td style={td()}>送信・送信ログ閲覧</td>
          </tr>
        </tbody>
      </table>

      <h2>招待手順</h2>
      <p>
        「<strong>ユーザー</strong>」タブを開き、画面右上の
        「<strong>+ メンバーを招待</strong>」ボタンをクリックします。
      </p>
      <ScreenshotBox src="/guide/screenshots/users-roles-1.png" caption="ユーザー招待モーダル" />
      <ol>
        <li>招待相手のメールアドレスを入力</li>
        <li>ロールを選択</li>
        <li>「招待メールを送信」をクリック → 招待メールが届く</li>
        <li>相手はメール内のリンクから当サービスのアカウントを作成 → 自動的にこのテナントに参加</li>
      </ol>

      <Callout type="info" title="招待リンクの有効期限">
        招待リンクは <strong>7 日間</strong>有効です。期限切れの場合は再招待してください。
      </Callout>

      <h2>招待状況の管理</h2>
      <p>
        招待中（未参加）のユーザーは別セクションに表示されます。
        以下の操作が可能:
      </p>
      <ul>
        <li><strong>リンクをコピー</strong>: 招待 URL を直接共有（メールが届かない場合はこちらを共有）</li>
        <li><strong>取り消し</strong>: 招待を無効化</li>
      </ul>
      <p style={{ fontSize: 13, color: "#6b6b68" }}>
        招待メールの再送信機能はありません。届かない場合は招待リンクをコピーして
        直接お渡しいただくか、いったん取り消して再度招待してください。
      </p>

      <h2>ロール変更・削除</h2>
      <p>
        ユーザー一覧の各行から、ロールの変更や削除ができます。
      </p>
      <Callout type="warning" title="オーナーのロールは変更できません">
        オーナーのロールは画面上から変更できません（自分自身・他のオーナーとも）。
        また、最後のオーナーを削除することもできません。
      </Callout>

      <h2>ログイン方式</h2>
      <p>
        当サービスはパスワード入力ではなく、以下のいずれかでログインします:
      </p>
      <ul>
        <li><strong>メールでログイン</strong>: ログインリンクをメールで受け取り、リンクをクリックしてログイン</li>
        <li><strong>Google でログイン</strong>: Google アカウントで認証</li>
      </ul>
      <p>
        ログイン状態は 30 日間維持されます。
      </p>

      <Callout type="tip" title="チームでの推奨運用">
        管理者は 1〜2 名に絞り、現場担当者は「メンバー」ロールで権限分離するのが推奨です。
        プロパティ設定など重要設定の意図せぬ変更を防げます。
      </Callout>
    </>
  );
}

function th() {
  return { textAlign: "left" as const, padding: "8px 12px", borderBottom: "1px solid #d0cfc9", fontSize: 13 };
}
function td() {
  return { padding: "8px 12px", borderBottom: "1px solid #f0efeb" };
}
